<template>
    
        <v-card  class="pb-100 teams" elevation=0 >
            <v-card-title class="pa-0">
                 
                <v-img  :src="(business.teamimage=='null' || business.teamimage==null )?bannerImg:business.teamimage" aspect-ratio="1" class="lighten-2 " max-height="287">
                    <v-row class="fill-height align-center" style="background:rgba(0,0,0, 0.4);">
                        <v-col cols="12" md="12" sm="12" class=" white--text pl-30">
                            <!-- <h2 class="heading" v-if="business.teamimagetitle==''">Your Team</h2> -->
                            <h2 class="heading" >{{business.teamimagetitle}}</h2>
                            <span class="body-1" v-if="business.teamimagedescription!=''">{{business.teamimagedescription}}</span>

                                    
                        </v-col>
                                
                    </v-row>
                            
                </v-img>
                        
                   
            </v-card-title>
            <v-card-text class="pl-3 pr-3">
            <v-expansion-panels style="margin-top:-40px">

                <v-expansion-panel v-for="(item,index) in business.departments" :key="index">
                    <v-expansion-panel-header class="pb-1">
                        
                            <v-col cols="3" md="3" sm="3" class="pl-0 pr-0">
                                <v-img :src="item.department.image" max-height="100" v-if="item.department.image!=null"></v-img>
                                <v-img :src="business.logo" max-height="100" v-else-if="business.logo!=''"></v-img>
                                <!-- <img :src="item.image"/> -->
                            </v-col>
                            <v-col cols="9" md="9" sm="9">
                                <div class="subtitle-2 font-weight-bold">{{item.department.departmentName}}</div>
                                <div class="body-2" v-if="item.department.departmenttext!=null">{{item.department.departmenttext}}</div>
                            </v-col>
                           
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="subtitle-1" v-if="item.staff.length>0">Department Staff</div>
                        <v-slide-group multiple show-arrows=false v-if="item.staff.length>0">
                            <v-slide-item
                                v-for="(itemstaff,i) in item.staff" :key="i" style="max-width:80px;">
                                <a  @click="teamdetails(itemstaff.id)">  
                                <v-row >
                                    <v-col cols="12" md="12" sm="12" class="text-center pb-0" style="max-height:100px;min-height: 70px;">
                                    <v-avatar class="mr-1" >
                                        <img :src="itemstaff.image" :alt="itemstaff.name+' '+itemstaff.lastname"/>
                                        
                                    </v-avatar>
                                    </v-col>
                                    <v-col cols="12" md="12" sm="12" class="caption text-center pt-0 pb-0" style="white-space: normal;word-wrap: normal;">
                                    <p>{{itemstaff.designation}}</p>
                                    </v-col>
                                </v-row>
                                </a>
                            </v-slide-item>
                        </v-slide-group>
                    </v-expansion-panel-content>
                </v-expansion-panel>

            </v-expansion-panels>
            </v-card-text>
             <!-- <v-card-text class="mb-auto pwa-content pa-0 ">
                <v-row v-for="(item, index) in departments" :key="index">
                    
                  <a href="#" target="_blank" class="w-100">
                         <v-col cols="12" md="12" sm="12" class="pt-1 pb-1">
                            <v-card class="ml-2 mr-2">
                                <v-card-text class="pl-2 pr-2 " >
                                    <v-row>
                                        <v-col cols="4" md="4" sm="4" class="pl-20">
                                            <v-img :src="item.image" max-height="100" v-if="item.image!=null"></v-img>
                                        </v-col>
                                        <v-col cols="8" md="8" sm="8" class="pl-20">
                                            <div class="subtitle-2 font-weight-bold">{{item.departmentName}}</div>
                                            <div class="body-2" v-if="item.departmenttext!=null">{{item.departmenttext}}</div>
                                        </v-col>
                                    </v-row>    
                                </v-card-text>
                            </v-card>
                        </v-col> 

                    </a>
                </v-row>
            </v-card-text>-->
        </v-card>
       
</template>
<script>
import Vue from 'vue'
import { EventBus } from '@/event-bus';
export default {

    data: () => 
    ({
        bannerImg:require('@/assets/overview-banner.jpg'),
       // bannerImg:'',
        logoImg:require('@/assets/logo.svg'),
        loading:false,
        isUsed: false,
        search: null,
        valid: true,
        isAgent: false,
        isSameUser:false,
        business_id: 0,
        businesses: [],
        storeBusiness: [],
        tagBusiness: {},
        code:0,
        starrating:0,
        activeBtn: 3,
        
       
        data:[],
        eventcategories:[],
        eventtype_id:0,
        eventtypes:[],
        departments:[],
        dimage:'',
        
    }),
    props:['business'],
   
    methods:
    {

        
       
       
        teamdetails(teamid)
        {
          //   this.$router.push({name:'teamdetails',params:{id: teamid}});
           EventBus.$emit('teamclick', teamid);
        },

        
   
    },
    
}
</script>

<style scope>
    .teams .v-slide-group__prev {
        display: none;
    }
    .teams .v-slide-group__next{
        display: none;
    }
    .txt-orange{
        color: #FE5800;
    }
    .back{
        background: #FE5800;
    }
    .eventdateshow{
        
        
        background: #FE5800;
        color: #fff;
        font-size: 18px;
        
    }
    .mb-10{
        margin-bottom: 5rem;
    }
    .mb-35
    {
        margin-bottom: 35px;
    }
    .pte-15{
        padding-top:3rem !important;
    }
    .pwa-content{
        margin-top: -46px;
    }
    .f-btn .v-btn__content
    {
        -webkit-box-orient: vertical;

    -webkit-box-direction: reverse;

    -ms-flex-direction: column-reverse;

    flex-direction: column-reverse;
    }
    .mt-60-n{
        margin-top:-60px;
    }
    .pb-100{
        padding-bottom: 100px;
    }
    .v-card__title{
        word-break: normal;
    }
    .align-cnt
    {
        text-align: center;
    }
</style>